export interface Response {
	nextCallTimestamp: string;
	sessionExpiryTime?: string;
}

const RETRY_HTTP_CODES = [408, 500, 502, 503, 504, 522, 524];

function timeout(ms: number) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

async function fetchRetry(
	url: string,
	options = {},
	retries = 5,
	backoff = 300,
): Promise<globalThis.Response | undefined> {
	const response = await fetch(url, options);

	if (response.ok || response.status === 401) {
		return response;
	}

	if (retries > 0 && RETRY_HTTP_CODES.includes(response.status)) {
		await timeout(backoff);
		return await fetchRetry(url, options, retries - 1, backoff * 2);
	} else {
		return Promise.reject(response);
	}
}

export const postHeartbeat = async (
	endpoint: string,
	onAuthenticationFailed?: () => void,
	onBadRequest?: () => void,
): Promise<Response | void> => {
	try {
		const response = await fetchRetry(endpoint, {
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		if (response && response.ok) {
			return response.json();
		}

		if (response && response.status === 401 && onAuthenticationFailed) {
			onAuthenticationFailed();
			return;
		}
	} catch (e) {
		const errorResponse = e as globalThis.Response;

		if (errorResponse.status === 400) {
			onBadRequest?.();
			return Promise.reject(errorResponse);
		}

		if (RETRY_HTTP_CODES.includes(errorResponse.status)) {
			// Silent failure - network retry limit reached, let framework handle
		}
	}
};
